(function () {
  if (window.__ruWow) return; window.__ruWow = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var $ = function (s, r) { return (r || document).querySelector(s); };
    var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

    /* Scroll reveals */
    var rev = $$('.ruw-reveal');
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      rev.forEach(function (el) { io.observe(el); });
    } else { rev.forEach(function (el) { el.classList.add('is-in'); }); }

    /* Hero parallax + pointer depth */
    var hero = $('[data-ruw-hero]');
    if (hero && !reduce) {
      var bg = $('[data-ruw-parallax]', hero), ticking = false;
      var onScroll = function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var y = Math.min(window.scrollY, hero.offsetHeight);
          if (bg) bg.style.transform = 'translate3d(0,' + (y * 0.18).toFixed(1) + 'px,0)';
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
      if (window.matchMedia('(pointer:fine)').matches) {
        hero.addEventListener('mousemove', function (e) {
          var r = hero.getBoundingClientRect();
          hero.style.setProperty('--mx', ((e.clientX - r.left) / r.width - 0.5).toFixed(3));
          hero.style.setProperty('--my', ((e.clientY - r.top) / r.height - 0.5).toFixed(3));
        });
      }
    }

    /* Fantasy tabs */
    $$('[data-ruw-tabs]').forEach(function (wrap) {
      var tabs = $$('[role=tab]', wrap), panels = $$('[role=tabpanel]', wrap);
      function select(i, focus) {
        tabs.forEach(function (t, j) {
          var on = i === j;
          t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
          if (panels[j]) panels[j].hidden = !on;
        });
        if (focus) tabs[i].focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = tabs.length;
          if (k === 'ArrowRight' || k === 'ArrowDown') { e.preventDefault(); select((i + 1) % n, true); }
          else if (k === 'ArrowLeft' || k === 'ArrowUp') { e.preventDefault(); select((i - 1 + n) % n, true); }
          else if (k === 'Home') { e.preventDefault(); select(0, true); }
          else if (k === 'End') { e.preventDefault(); select(n - 1, true); }
        });
      });
    });

    /* Flip cards */
    $$('[data-ruw-flip]').forEach(function (card) {
      var btn = $('.ruw-flip__toggle', card);
      btn.addEventListener('click', function () {
        var on = card.classList.toggle('is-flipped');
        btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      card.addEventListener('keydown', function (e) { if (e.key === 'Escape') { card.classList.remove('is-flipped'); btn.setAttribute('aria-expanded', 'false'); } });
    });

    /* Series path */
    $$('[data-ruw-path]').forEach(function (path) {
      var list = $('.ruw-path__list', path), nodes = $$('[data-ruw-node]', path);
      function update() {
        var r = list.getBoundingClientRect(), vh = window.innerHeight;
        var p = (vh * 0.6 - r.top) / r.height; p = Math.max(0, Math.min(1, p));
        list.style.setProperty('--ruw-p', p.toFixed(3));
        nodes.forEach(function (n) {
          var nr = n.getBoundingClientRect();
          n.classList.toggle('is-lit', nr.top < vh * 0.6);
        });
      }
      window.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update); update();
    });

    /* Excerpt */
    $$('[data-ruw-excerpt]').forEach(function (page) {
      var btn = $('[data-ruw-excerpt-btn]', page);
      btn.addEventListener('click', function () {
        var on = page.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        btn.textContent = on ? 'Show less' : 'Read the first pages';
      });
    });

    /* Count up */
    $$('[data-ruw-count]').forEach(function (el) {
      var target = parseInt(el.getAttribute('data-ruw-count'), 10); if (!target || reduce || !('IntersectionObserver' in window)) return;
      var done = false;
      new IntersectionObserver(function (es, o) {
        es.forEach(function (e) {
          if (!e.isIntersecting || done) return; done = true; o.disconnect();
          var t0 = performance.now(), dur = 1400;
          (function step(t) {
            var k = Math.min(1, (t - t0) / dur); k = 1 - Math.pow(1 - k, 3);
            el.textContent = Math.round(target * k);
            if (k < 1) requestAnimationFrame(step);
          })(t0);
        });
      }, { threshold: 0.4 }).observe(el);
    });

    /* Sticky mobile buy bar */
    var bar = $('[data-ruw-sticky]');
    if (bar) {
      bar.hidden = false;
      var target = $(bar.getAttribute('data-target')) || $('product-form') || $('.product-form');
      if (target && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            var above = e.boundingClientRect.top < 0;
            bar.classList.toggle('is-on', !e.isIntersecting && above);
          });
        }, { threshold: 0 }).observe(target);
      }
    }

    /* Free-book pop-up: once per visit, after time on page plus deep scroll or desktop exit intent */
    var pop = $('[data-ruw-pop]');
    if (pop) {
      var KEY = 'ruw_pop_seen', WEEK = 7 * 24 * 3600 * 1000, opened = false, lastFocus = null;
      var seenRecently = function () { try { var t = parseInt(localStorage.getItem(KEY), 10); return t && (Date.now() - t) < WEEK; } catch (e) { return false; } };
      var mark = function () { try { localStorage.setItem(KEY, String(Date.now())); sessionStorage.setItem(KEY, '1'); } catch (e) {} };
      var closePop = function () {
        pop.hidden = true; document.body.classList.remove('ruw-pop-open'); mark();
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      };
      var openPop = function (force) {
        if (opened) return;
        if (!force && (seenRecently() || sessionStorage.getItem(KEY))) return;
        opened = true; lastFocus = document.activeElement; pop.hidden = false; document.body.classList.add('ruw-pop-open');
        var f = $('input[type=email]', pop) || $('a,button', pop); if (f) setTimeout(function () { f.focus(); }, 60);
      };
      $$('[data-ruw-pop-close]', pop).forEach(function (b) { b.addEventListener('click', closePop); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) closePop(); });
      var path = location.pathname;
      var skip = /^\/(cart|checkout|account)/.test(path) || document.querySelector('.ruw-optin__ok');
      if (document.querySelector('.ruw-optin__ok')) mark();
      if (location.hash === '#pop') { openPop(true); }
      else if (!skip) {
        var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 10) * 1000, ready_ = false;
        setTimeout(function () { ready_ = true; }, delay);
        var check = function () {
          if (!ready_ || opened) return;
          var h = document.documentElement, depth = (window.scrollY + window.innerHeight) / h.scrollHeight;
          if (depth > 0.7 && h.scrollHeight > window.innerHeight * 1.8) openPop(false);
        };
        window.addEventListener('scroll', check, { passive: true });
        setInterval(check, 2000);
        if (window.matchMedia('(pointer:fine)').matches) {
          document.addEventListener('mouseout', function (e) { if (ready_ && !e.relatedTarget && e.clientY <= 0) openPop(false); });
        }
      }
    }

    /* One-click buy: Buy now goes straight to checkout, Add to cart opens the cart popup */
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-ruw-buy]') : null;
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      if (a.getAttribute('aria-busy') === 'true') return;
      var id = a.getAttribute('data-ruw-buy'), mode = a.getAttribute('data-mode') || 'now';
      var label = a.querySelector('.ruw-btn__t') || a, orig = label.textContent;
      a.setAttribute('aria-busy', 'true'); label.textContent = mode === 'now' ? 'Taking you to checkout' : 'Adding';
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var fd = new FormData(); fd.append('id', id); fd.append('quantity', '1');
      if (mode !== 'now' && cart && cart.getSectionsToRender) {
        fd.append('sections', cart.getSectionsToRender().map(function (x) { return x.id; }));
        fd.append('sections_url', window.location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(a);
      }
      var url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || 'add failed');
          if (mode === 'now') { window.location.href = '/checkout'; return; }
          label.textContent = 'Added';
          a.classList.add('is-added');
          if (cart && cart.renderContents) cart.renderContents(res); else window.location.href = '/cart';
          setTimeout(function () { label.textContent = orig; a.classList.remove('is-added'); }, 2600);
        })
        .catch(function () { window.location.href = a.getAttribute('href'); })
        .finally(function () { a.removeAttribute('aria-busy'); });
    });
  });
})();
